import gql from 'graphql-tag'

export const GRUPO_USUARIOS_DOMINIO_QUERY = gql`
  query GetGrupoUsuariosDominioQuery {
    usuarioLogado {
      id
      tipo {
        id
      }
      tiposUsuarios {
        id
        description
      }
      marcas {
        id
        description
      }
      funcionalidades {
        chave
      }
      produtos {
        id
        nome
        tiposAcesso {
          id
          nome
          tiposUsuario {
            id
            description
          }
        }
      }
    }
    dealers {
      id
      nomeExibicao
      active
      marcas {
        id
        description
      }
    }
  }
`
